'use strict';

import { BaseController } from '../../../../../common/base/controller';
import { statusStateName } from '../../../status.state';
import moment from 'moment';

export default class StatusVerifyModalController extends BaseController {
  info = {};

  constructor(controllerService, $scope) {
    'ngInject';
    super({
      controllerService,
      $scope,
    });
  }

  $onInit() {
    this.messages = {
      required: 'app.status.verify.birthday.required',
    };

    this.dateOptions = {
      dateFormat: 'dd.MM.yyyy',
      showWeeks: false,
    };

    const { invalidBirthday, id, orderId } = this.$stateParams;
    this.invalidBirthday = invalidBirthday;
    this.orderId = orderId || id;

    this.setLanguageOptions().then(() => {
      this.dateOptions.dateFormat = this.languageOptions.mediumDate;
    });
  }

  close() {
    this.modalInstance.close();
  }

  submit() {
    this.close();
    this.go(statusStateName, {
      orderId: this.orderId,
      token: moment(this.birthday).unix(),
    });
  }

  isInvalid() {
    return this.form.$invalid;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/status/verify/components/statusVerifyModal/statusVerifyModal.controller.js